// extracted by mini-css-extract-plugin
export default {"textError":"styles-module__textError__src-labstep-web-core-Text-Error-_n_GCJ"};